import React from 'react';
export class VideoCameraSlashSolid extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("svg", { className: this.props.className || 'w-5 h-5', viewBox: '0 0 24 24', fill: 'currentColor', style: this.props.style },
                    React.createElement("path", { clipRule: 'evenodd', fillRule: 'evenodd', d: 'M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.5 17.69c0 .471-.202.86-.504 1.124l-4.746-4.746V7.939l2.69-2.689c.944-.945 2.56-.276 2.56 1.06v11.38zM15.75 7.5v5.068L7.682 4.5h5.068a3 3 0 013 3zM1.5 7.5c0-.782.3-1.494.79-2.028l12.846 12.846A2.995 2.995 0 0112.75 19.5H4.5a3 3 0 01-3-3v-9z' }))));
        };
    }
}
